import React, { useState } from "react";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Modal, Button, Input, message, Select } from "antd";
import "./style.less";

const TextArea = Input.TextArea;

const App = () => {

    const [loading, setLoading] = useState(false);
    const [name, setName] = useState(undefined);
    const [orgName, setOrgName] = useState(undefined);
    const [post, setPost] = useState(undefined);
    const [phone, setPhone] = useState(undefined);
    const [intention, setIntention] = useState(undefined);
    const [[{ title = "", show, hide, width = 300, meetingId, meetingName }]] = useWatchState(["modal.meetingSignUp"])

    const onSign = async () => {
        if (!name) return message.warn("请输入姓名！");
        if (!phone) return message.warn("请输入电话！");
        setLoading(true)
        // 先判断是否已经报过名了
        const res = await BaseService.list({
            table: "thtt_meeting_user",
            where: {
                meeting_id: meetingId, name, phone, is_delete: 0
            }
        })
        if (res.data.result.length) return message.warn("您已经报过名了！")

        const addRes = await BaseService.add({
            table: "thtt_meeting_user",
            data: { meeting_id: meetingId, name, unit: orgName, post, phone, intention, add_time: Math.floor(new Date().getTime() / 1000) }
        });
        setLoading(false)
        if (addRes.data.status !== 200) {
            message.error(addRes.data.msg);
            return;
        }
        message.success("报名成功");
        hide();
    }

    return (
        <Modal
            className="modal-courseSignUp"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div className="modal-courseSignUp__body child-top-sm p-md-lr">
                <p className="font-size-14 child-left-sm"><span className="dark-disable">您即将报名</span><span>{meetingName}</span></p>
                <Input placeholder="请输入您的姓名" onChange={e => setName(e.target.value)} />
                <Input placeholder="请输入您的电话" onChange={e => setPhone(e.target.value)} />
                <Input placeholder="请输入您的单位" onChange={e => setOrgName(e.target.value)} />
                <Input placeholder="请输入您的职务" onChange={e => setPost(e.target.value)} />
                <TextArea placeholder="请输入您的意向" onChange={e => setIntention(e.target.value)} />
                <div className="modal-courseSignUp__btn child-left-sm flex">
                    <Button type="default" onClick={hide}>取消</Button>
                    <Button className="full" onClick={onSign}>预约报名</Button>
                </div>
            </div>
        </Modal>
    );
}

export default App;